// Shared CodeMirror editor sx styles.
// Import `codeMirrorEditorStyles` and spread it into any Box wrapping a CodeMirrorView.
// Use `codeMirrorEditorStylesFill` when the editor must fill the available height
// (e.g. inside a modal or flex container with a fixed height).

const base = {
    "& .CodeMirror": {
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "greyscale.200",
        fontSize: 13,
        fontFamily: '"Consolas", "Monaco", "Andale Mono", "Ubuntu Mono", monospace',
        lineHeight: 1.6,
        backgroundColor: "greyscale.50",
    },
    "& .CodeMirror-gutters": {
        border: "none",
        borderRadius: "8px 0 0 8px",
        backgroundColor: "greyscale.100",
    },
    "& .CodeMirror-linenumber": {
        color: "greyscale.500",
        fontSize: 12,
    },
    "& .CodeMirror-cursor": {
        borderLeftColor: "primary.main",
    },
};

// For inline use — grows to fit content, minimum height enforced
export const codeMirrorEditorStyles = {
    ...base,
    "& .CodeMirror": {
        ...base["& .CodeMirror"],
        minHeight: 120,
    },
};

// For modal / full-height use — stretches to fill a flex parent
export const codeMirrorEditorStylesFill = {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    ...base,
    "& .CodeMirror": {
        ...base["& .CodeMirror"],
        height: "100%",
    },
    "& .CodeMirror-scroll": {
        height: "100%",
    },
};
